"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDepositValues = void 0;
var any_ascii_1 = __importDefault(require("any-ascii"));
var normalizeDepositValues = function (values) {
    var result = {};
    Object.entries(values).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'string') {
            ;
            result[key] = (0, any_ascii_1.default)(value);
        }
        else {
            ;
            result[key] = value;
        }
    });
    return result;
};
exports.normalizeDepositValues = normalizeDepositValues;
